import { useEffect } from "react";
import { getCalApi } from "@calcom/embed-react";
import { useToast } from "@/hooks/use-toast";

const CAL_API_KEY = "cal_live_263b436f4e2cc01d862fdf779ce07f7f";

export const CalendarWidget = () => {
  const { toast } = useToast();

  useEffect(() => {
    (async function initCal() {
      try {
        console.log("Initializing Cal.com widget");
        const cal = await getCalApi();
        
        // Initialize with API key
        cal("init", {
          apiKey: CAL_API_KEY,
          debug: true
        });

        cal("ui", {
          theme: "light",
          styles: {
            branding: { brandColor: "#000000" },
            enabledDateTheme: { background: "#000000" }
          },
          hideEventTypeDetails: false,
          layout: "month_view"
        });
        
        console.log("Cal.com widget initialized successfully");
      } catch (error) {
        console.error("Failed to initialize Cal.com widget:", error);
        toast({
          title: "Error",
          description: "Failed to load booking calendar. Please try again later.",
          variant: "destructive",
        });
      }
    })();
  }, [toast]);

  return null;
};